// extracted by mini-css-extract-plugin
module.exports = {"button":"UserWayTrigger_button__l2UGt"};